<template>
    <div>
        <a class="question-icon" v-b-modal="'question-modal'">
            <QuestionSvgIcon></QuestionSvgIcon>
        </a>
        <b-modal id="question-modal" cancel-disabled>
            <div v-html="$t('common.questionButtonModalText')"></div>

            <template #modal-title>
                <div v-html="$t('common.questionTitel')"></div>
            </template>
        </b-modal>
    </div>
</template>
<script>
import QuestionSvgIcon from "../Icons/QuestionSvgIcon";
export default {
    name: 'Question',
    components: {QuestionSvgIcon},
    props: {
        currentStep: {
            type: Number
        }
    },
}
</script>
